import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface CleanUpProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const CleanUp: React.FC<CleanUpProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [cleanUp, set_cleanUp] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Clean Up']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Clean Up': [b.values?.['Final Structure']?.['Clean Up']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Clean Up';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(cleanUp)}
                />
            ) : (
                <MoneyBox
                    id={'cleanUp'}
                    allowNegative={false}
                    value={cleanUp}
                    onChange={(value) => set_cleanUp(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
